import axios from "axios";

// Vote on a list (valid, debatable, trash)
export const VoteOnList = async (
  listId: string,
  voteType: string,
  headers: any,
) => {
  const res = await axios.post(
    `/api/lists/${listId}/vote`,
    { voteType },
    headers,
  );
  return res.data;
};

// Vote on a list item placement (too_high, right_spot, too_low)
export const VoteOnListItem = async (
  listId: string,
  listItemId: string,
  voteType: string,
  headers: any,
) => {
  const res = await axios.post(
    `/api/lists/${listId}/items/${listItemId}/vote`,
    { voteType },
    headers,
  );
  return res.data;
};
